import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=6ee499b4"
import script from "./BannerPage.vue?vue&type=script&lang=js"
export * from "./BannerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports